import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";
import { observer } from "mobx-react";

export default observer(function TransactionCancelConfirmModal() {
	const {
		showConfirmationModal,
		setShowConfirmationModal,
		cancelWithdrawalTransaction,
		disableCancelConfirmationTransaction,
	} = useContext(WithdrawalContext);

	const { t } = useTranslation("payment");

	if (showConfirmationModal === false) {
		return null;
	}

	const onExitTransactionCancel = () => {
		setShowConfirmationModal(false);
	};

	const onConfirmTransactionCancel = () => {
		cancelWithdrawalTransaction();
	};

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__header">
					{t("WITHDRAWAL.CONFIRMATION_LABEL")}
				</div>
				<div className="popup__body">
					{t("WITHDRAWAL.CANCEL_CONFIRM")}
				</div>
				<div className="popup__footer">
					<button
						className="popup__btn btn btn--med btn--primary--inverted"
						type="button"
						disabled={disableCancelConfirmationTransaction}
						onClick={onExitTransactionCancel}
					>
						{t("COMMON.CANCEL")}
					</button>
					<button
						className="popup__btn btn btn--med btn--accent"
						type="button"
						disabled={disableCancelConfirmationTransaction}
						onClick={onConfirmTransactionCancel}
					>
						{t("COMMON.CONFIRM")}
					</button>
				</div>
			</div>
		</div>
	);
});
